import { useCallback, useState } from 'react';
import transactionServices from 'services/transaction.service';
import { camelCaseObjNormalize } from 'helpers/utils';

export default function useFetchSubsidyTransactionData() {
  const [subsidyTransactionList, setSubsidyTransactionList] = useState({});
  const [subsidyTransactionDetail, setSubsidyTransactionDetail] = useState({});
  const [loadingList, setLoadingList] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);

  const fetchListSubsidyTransaction = useCallback(async body => {
    try {
      setLoadingList(true);
      const data = await transactionServices.listSubsidiesPortal(body);
      setSubsidyTransactionList(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingList(false);
    }
  }, []);

  const fetchSubsidyTransactionDetail = useCallback(async id => {
    try {
      setLoadingDetail(true);
      const data = await transactionServices.detailSubsidy(id);
      setSubsidyTransactionDetail(camelCaseObjNormalize(data));
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingDetail(false);
    }
  }, []);

  const resetSubsidyTransactionDetail = () => {
    setSubsidyTransactionDetail({});
  };

  return {
    loadingDetail,
    loadingList,
    subsidyTransactionList,
    subsidyTransactionDetail,
    fetchListSubsidyTransaction,
    fetchSubsidyTransactionDetail,
    resetSubsidyTransactionDetail
  };
}
